/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .factory('NodeShareLink', ['$resource', 'LinksInterceptor', 'LinkBuilder',
        function ($resource, LinksInterceptor, LinkBuilder) {
            function transformLinkRequest(link) {
                delete(link.node);
                delete(link.sid);
                delete(link.note);
                delete(link.isShared);
                delete(link.hasPassword);

                return angular.toJson(link);
            }

            var resource = $resource('/sync_and_share_nodes/:node_uuid/links/:id', {node_uuid: '@node_uuid', id: '@id' }, {
                query: {
                    method: 'GET',
                    isArray: true,
                    interceptor: LinksInterceptor
                },
                removeAll: {
                    method: 'DELETE'
                },
                remove: {
                    method: 'DELETE'
                },
                update: {
                    method: 'PUT'
                },
                save: {
                    method: 'POST',
                    transformRequest: transformLinkRequest
                },
                saveAll: {
                    method: 'POST',
                    transformRequest: transformLinkRequest,
                    isArray: true
                }
            });

            resource.buildEmailLinkFromFile = function(node) {
                return LinkBuilder(new resource).buildEmailLinkFromFile(node)
            };

            resource.buildGetLinkFromFile = function(node) {
                return LinkBuilder(new resource).buildGetLinkFromFile(node)
            };

            return resource;
        }]);
